import React from 'react'
import { MDBContainer, MDBRow, MDBCol,MDBIcon, MDBCard, MDBCardHeader, MDBCardBody, MDBCardFooter, MDBBtn } from 'mdbreact'

export default function carrers() {
    return (
        <div>
            <section>

            </section>
            <section style={{marginTop:"150px"}}>
                <MDBContainer className="p-3">
                    <MDBRow>
                        <MDBCol md="8">
                            <MDBCard className="z-depth-3">
                                <MDBCardHeader>Looking For Sr Executive / ASO @ Bayyavaram, Uppal</MDBCardHeader>
                                <MDBCardBody>
                              <span><MDBIcon icon="briefcase" size="1x" className="m-2" />1-5yrs exp</span><span><MDBIcon icon="rupee-sign"  size="1x" className="m-2" />not disclosed</span><span><MDBIcon icon="map-pin"  size="1x" className="m-2" />vizag</span><br />
                                Qualification: Any GraduationResponsible to submit
                                     required reports on periodical basis to your reporting authorityResponsible to 
                                    coordinate and ensure the availability of Quality and Trained security…</MDBCardBody>
                                <MDBCardFooter> 
                                       Posted 3 weeks ago<MDBBtn rounded outline color="info">Apply on Linkedin<MDBIcon size="1x" fab icon="linkedin" className="ml-2" /></MDBBtn>
                                </MDBCardFooter>
                            </MDBCard>
                            <MDBCard className="z-depth-3 mt-2">
                                <MDBCardHeader>Looking For Sr Executive / ASO @ Bayyavaram, Uppal</MDBCardHeader>
                                <MDBCardBody>
                              <span><MDBIcon icon="briefcase" size="1x" className="m-2" />1-5yrs exp</span><span><MDBIcon icon="rupee-sign"  size="1x" className="m-2" />not disclosed</span><span><MDBIcon icon="map-pin"  size="1x" className="m-2" />vizag</span><br />
                                Qualification: Any GraduationResponsible to submit
                                     required reports on periodical basis to your reporting authorityResponsible to 
                                    coordinate and ensure the availability of Quality and Trained security…</MDBCardBody>
                                <MDBCardFooter> 
                                       Posted 3 weeks ago<MDBBtn rounded outline color="info">Apply on Linkedin<MDBIcon size="1x" fab icon="linkedin" className="ml-2" /></MDBBtn>
                                </MDBCardFooter>
                            </MDBCard>
                        </MDBCol>
                        <MDBCol md="4">
                            <MDBCard className="p-5">
                                <h3>Drop your CV here</h3>
                                <h6>We will consider your Profile for future Jobs</h6>
                                <br />
                                <MDBBtn type="">Drop Cv</MDBBtn>
                            </MDBCard>
                        </MDBCol>
                    </MDBRow>
                </MDBContainer>
            </section>
        </div>
    )
}
